import React from 'react';
import { DashboardLayout } from '@typedbootstrap/admin-components';
import { Footer, Sidenav, DetailTopnav } from 'components/organisms';
import { useAppSelector } from 'hooks';
import { selectSidebarToggled } from 'store/uiSlice';

export interface DetailTemplateProps {
    children?: React.ReactNode;
}

const DetailTemplate: React.FC<DetailTemplateProps> = ({ children }) => {
    const sidebarToggled = useAppSelector(selectSidebarToggled);

    return (
        <DashboardLayout
            topnav={<DetailTopnav />}
            sidenav={<Sidenav />}
            sidenavToggled={sidebarToggled}
            footer={<Footer />}
            topnavFixed={true}
        >
            <main>{children}</main>
        </DashboardLayout>
    );
};

export default DetailTemplate;
